<template>
  <div
    class="Container--content-centered-vertical Container--full-width Container--full-height Bg_solid text-center px-4 text-white"
  >
    <div class="Centered-content-container">
      <div class="Bg_gradient-image-content">
        <Logo class="Icon Icon--logo" />
        <img src="~@/assets/images/home-main-image-compressed.png" alt="People reading openday planner booklet" style="width: calc(100% + 2rem); margin-left: -1rem; max-width: none;"/>
        <!-- eslint-disable-next-line vuejs-accessibility/alt-text -->
        <!-- <img src="~@/assets/images/open-day-planner-heading.svg" aria-hidden="true" class="mb-24 open-day-heading" style="width: calc(100% - 8rem); margin: -0.5rem auto 2rem; max-width: none;"/> -->
        <!-- <h1 class="sr-only">Open Day Planner</h1> -->
         <!-- eslint-disable-next-line vuejs-accessibility/heading-has-content -->
         <h1 class="mb-24 open-day-heading" aria-label="Open day planner"><OpenDayPlannerText aria-hidden="true"/></h1>
        <div class="w-10/12 m-auto">
          <p class="text-lg font-normal mb-2">
            {{ $opendayPrint }} | 9am-3pm
          </p>
          <!-- <p class="text-lg font-delta mb-16 font-italics">Discover the real QUT.</p> -->
          <p class="text-sm text-center">There is a lot happening at QUT Open Day. Use this planner to organise your day. Events are walk-in only: it is not possible to reserve spots.</p>
          <p class="text-sm text-center">Create your plan now and enter the draw for a chance to win a MacBook Pro.*</p>
          <div id="qualtrics-planner-useful-feedback" class="w-full"></div>
          <!-- <div class="p-4 bg-white my-8">
            <p class="text-lg text-black">Open Day will be held on Sunday, rain or shine. Some activities may change so <a href="https://www.qut.edu.au/study/events/qut-open-day-2023">check the website for details</a></p>
          </div> -->

          <!-- <a href="#" v-if="showLoginLink" @click.prevent="login" class="block">Already made a plan? Log in.</a> -->
          <div class="w-100">
            <button class="Button mb-4 mt-4 sm:mt-8 focus-outline-white" @click.prevent="login">Access my plan</button>
          </div>
          <div class="w-100">
            <button :class="['mb-6 sm:mb-12 focus-outline-white', todayOpenday ? 'underline' : 'Button Button--alt-green']" @click="getStarted">Create new plan</button>
          </div>
          <small class="text-xs block">* Terms and conditions apply</small>
          <small class="text-xs block">TEQSA Provider ID: <a href="https://www.teqsa.gov.au/national-register/provider/queensland-university-technology">PRV12079</a> (Australian University) | CRICOS No. <a href="https://cricos.education.gov.au/Institution/InstitutionDetails.aspx?ProviderCode=00213J">00213J</a></small>
        </div>
      </div>

      <LoginModal :show="isLoginModalVisible" completedUrl="/get-started" @close="closeLoginModal" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Logo from '@/components/svg/Logo.vue';
import OpenDayPlannerText from '@/components/svg/OpenDayPlannerText.vue';
import LoginModal from '@/components/LoginModal.vue';
import dayjs from 'dayjs';

export default {
  components: {
    Logo,
    LoginModal,
    OpenDayPlannerText,
  },
  data() {
    return {
      isLoginModalVisible: false,
    };
  },
  computed: {
    ...mapGetters({
      isRespondentAuthenticated: 'respondent/isAuthenticated',
      isRespondentPreAuthenticated: 'respondent/isPreAuthenticated',
    }),
    showLoginLink() {
      return !this.isRespondentAuthenticated && !this.isRespondentPreAuthenticated;
    },
    todayOpenday(){
      return dayjs(this.$opendayDate).format('MDD') === dayjs().format('MDD');
    },
  },
  methods: {
    getStarted() {
      window.dataLayer.push({
        event: 'Click',
        action: 'Get started',
        label: this.$route.name,
      });

      this.$router.push('/get-started');
    },

    login() {
      this.isLoginModalVisible = !this.isLoginModalVisible;
      const action = this.isLoginModalVisible ? 'Open' : 'Close';

      window.dataLayer.push({
        event: 'SignIn',
        action: `Form ${action}`,
        label: this.$route.name,
      });
    },

    closeLoginModal() {
      this.isLoginModalVisible = false;
    },
  },
};
</script>

<style scoped lang="scss">
.font-italics {
  font-style: italic;
}

.open-day-heading {
  width: calc(100% - 8rem);
  margin: -0.5rem auto 2rem;
  max-width: none;
  @media (max-width: 450px) {
    width: calc(100% - 6rem);
  }

  @media (max-width: 360px) {
    width: calc(100% - 4rem);
  }
}
</style>
